var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.18,
    height: 33.18,
    viewBox: "0 0 33.18 33.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_shield-tick",
    "data-name": "vuesax/bulk/shield-tick",
    transform: "translate(-300 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield-tick",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.761.221,2.774,3.135A4.518,4.518,0,0,0,0,7.053V18.512A4.655,4.655,0,0,0,1.714,21.85L9.7,27.664a4.628,4.628,0,0,0,5.126,0l7.987-5.814a4.681,4.681,0,0,0,1.714-3.338V7.053a4.5,4.5,0,0,0-2.774-3.9L13.767.235A5.065,5.065,0,0,0,10.761.221Z",
    transform: "translate(4.32 2.317)",
    fill: "#22c663",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.869,7.055a.9.9,0,0,1-.645-.268L.265,4.828a.912.912,0,0,1,1.29-1.29L2.869,4.853,7.457.265a.912.912,0,1,1,1.29,1.29L3.514,6.788A.9.9,0,0,1,2.869,7.055Z",
    transform: "translate(12.091 12.102)",
    fill: "#22c663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H33.18V33.18H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.42f45a3df10618b1a23e3bc45fcfafef.svg";
export { ForwardRef as ReactComponent };